<template>
  <div class="error-area ptb-80">
    <div class="container">
      <div class="error-content">
        <div class="notfound-404">
          <h1>404</h1>
        </div>
        <h3>Page Not Found</h3>
        <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
        <router-link to="/" class="btn btn-primary">Back to Homepage</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
  setup() {
    // Set document title
    document.title = '404 - Page Not Found - AtOnline.com'
  }
}
</script>

<style scoped>
.error-area {
  padding: 70px 0;
  min-height: 70vh;
  display: flex;
  align-items: center;
}

.error-content {
  text-align: center;
}

.notfound-404 {
  position: relative;
  height: 150px;
  margin-bottom: 30px;
}

.notfound-404 h1 {
  font-size: 150px;
  margin: 0;
  font-weight: 700;
  color: #44ce6f;
}

.error-content h3 {
  font-size: 30px;
  margin-bottom: 20px;
}

.error-content p {
  max-width: 500px;
  margin: 0 auto 30px;
}
</style>